import * as React from "react";
import { observer } from "mobx-react";
import { withStores } from "stores";
import { normalizeOptionsData } from "src/stores/FlexTemplateStore";
import { AdProps, AdViewProps, DisplayAdProps, AdFTNodeOptions } from "./typings";
import { Viewport, ViewSmall, ViewMedium, ViewLarge, ViewExtraLarge } from "bernie-view";
import { classNames } from "uitk-react-utils";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";

@observer
export class Ad extends React.Component<AdProps, {}> {
  public componentDidMount() {
    /* istanbul ignore next */
    this.props.advertising?.includeAd?.();
  }

  public render() {
    const { context, advertising, flexModuleModelStore, flexTemplateNode } = this.props;

    /* istanbul ignore next */
    if (
      !advertising ||
      !flexModuleModelStore ||
      !flexTemplateNode ||
      advertising.adsSuppressed ||
      !context?.site?.optInPrivacyInfo?.canTrack
    ) {
      return null;
    }

    const options = normalizeOptionsData(
      flexTemplateNode,
      flexModuleModelStore.getModel(flexTemplateNode.id)
    ) as AdFTNodeOptions;

    return <AdView data-testid="ad-component" id={flexTemplateNode.id} options={options} advertising={advertising} />;
  }
}

const extraLargeAd = "CT1";
const largeAd = "CT2";
const mediumAd = "CT3";
const smallAd = "CT4";

const DisplayAd = (props: DisplayAdProps) => {
  const { id, options, uci, advertising } = props;

  const overrideMarginTop = options.marginTopOverride === "sizing__three";
  const adMarginSpacing = overrideMarginTop ? "three" : "six";
  const displayAdClassNames = classNames("Ad", {
    "background-color-white": options.backgroundWhite,
  });

  return (
    <UitkSpacing margin={{ small: { blockstart: "six" }, block: adMarginSpacing }}>
      <div
        className={displayAdClassNames}
        id={id}
        data-fm={options.fmId}
        data-fm-title-id={options.fmTitleId}
        data-testid="display-ad"
      >
        <UitkLayoutFlex justifyContent="center">
          <UitkLayoutFlexItem>
            <div>
              <meso-display-ad uci={advertising?.adSlotIdOverride || uci} />
            </div>
          </UitkLayoutFlexItem>
        </UitkLayoutFlex>
      </div>
    </UitkSpacing>
  );
};

const AdView = observer((props: AdViewProps) => {
  const { options, id } = props;

  return (
    <Viewport>
      <ViewExtraLarge>
        <DisplayAd
          id={id}
          options={options}
          advertising={props.advertising}
          uci={options.extraLargeAd || extraLargeAd}
        />
      </ViewExtraLarge>
      <ViewLarge>
        <DisplayAd id={id} options={options} advertising={props.advertising} uci={options.largeAd || largeAd} />
      </ViewLarge>
      <ViewMedium>
        <DisplayAd id={id} options={options} advertising={props.advertising} uci={options.mediumAd || mediumAd} />
      </ViewMedium>
      <ViewSmall>
        <DisplayAd id={id} options={options} advertising={props.advertising} uci={options.smallAd || smallAd} />
      </ViewSmall>
    </Viewport>
  );
});

(AdView as React.SFC).displayName = "AdView";

export default withStores("advertising", "flexModuleModelStore")(Ad);
